export const teamDirectory = {
  contacts: [
    { name: 'Head of Design', role: 'Design Leadership', email: 'head-of-design@company.com', slack: '@head-design' },
    { name: 'UX Research Lead', role: 'Research Leadership', email: 'ux-research-lead@company.com', slack: '@research-lead' },
    { name: 'Product Manager', role: 'Product Strategy', email: 'product-manager@company.com', slack: '@product-manager' },
    { name: 'Data Analyst', role: 'Analytics Support', email: 'data-analyst@company.com', slack: '@data-analyst' }
  ],
  mentors: [
    { name: 'Senior UX Researcher Mentor', expertise: 'Research Methods & User Testing', availability: 'Mon-Fri 2-4 PM' },
    { name: 'Quantitative Research Mentor', expertise: 'Data Analysis & Statistical Methods', availability: 'Tue/Thu 10 AM-12 PM' },
    { name: 'Research Operations Mentor', expertise: 'Research Process & Tool Management', availability: 'Wed/Fri 3-5 PM' }
  ],
  collaborators: [
    { team: 'Design Team', contact: 'design-team@company.com', purpose: 'Research Integration & Design Validation' },
    { team: 'Product Team', contact: 'product-team@company.com', purpose: 'Research Planning & Insights Sharing' },
    { team: 'Engineering Team', contact: 'engineering-team@company.com', purpose: 'Technical Feasibility & Implementation Research' },
    { team: 'Marketing Team', contact: 'marketing-team@company.com', purpose: 'User Insights & Market Research' }
  ],
  channels: {
    primary: '#ux-research',
    announcements: '#research-announcements',
    help: '#research-help',
    insights: '#research-insights',
    methods: '#research-methods',
    tools: '#research-tools',
    collaboration: '#design-research-collab'
  }
};
